export const HEADER_COLOR = '#4392f1';
export const HEADER_COLOR_LIGHT = '#5DACFF';
export const HEADER_COLOR_LIGHTER = '#76C5FF';
export const HEADER_COLOR_LIGHTEST = '#90DFFF';
export const HEADER_COLOR_FINAL = '#A9F8FF';
export const PAGE_BORDER_WIDTH = 2;
export const FULL_WIDTH = 355 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 216;
export const SECTION_GAP_WIDTH = 2;
export const LINE_Y_OFFSET = 0.5;
export const LINE_X_OFFSET = 0.5;
export const HEADER_HEIGHT = 24;
export const HEADER_WIDTH = FULL_WIDTH;
export const HEADER_LEFT = PAGE_BORDER_WIDTH;
export const HEADER_TOP = PAGE_BORDER_WIDTH;
export const ROW_SECTION_HEADER_HEIGHT = 4;
export const THIN_LINE = 0.25;
export const THICK_LINE = 0.5;

export const HEADER_1_SIZE = 9;
export const HEADER_2_SIZE = 7;
export const LOGO_LEFT = 2;
export const LOGO_TOP = PAGE_BORDER_WIDTH;
export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 23;

export const OPERATOR_CONTRACTOR_TOP = PAGE_BORDER_WIDTH + 2;
export const OPERATOR_CONTRACTOR_LEFT = PAGE_BORDER_WIDTH + LOGO_WIDTH + 10;
export const OPERATOR_CONTRACTOR_WIDTH = 230;
export const OPERTAOR_CONTRACTOR_HEIGHT = 20;

export const DEPTH_TOP = PAGE_BORDER_WIDTH + 2;
export const DEPTH_LEFT = OPERATOR_CONTRACTOR_LEFT + OPERATOR_CONTRACTOR_WIDTH;
export const DEPTH_WIDTH = FULL_WIDTH - DEPTH_LEFT - PAGE_BORDER_WIDTH;
export const DEPTH_HEIGHT = OPERTAOR_CONTRACTOR_HEIGHT;

export const ROW_HEADERS_BIG_TOP = HEADER_TOP + HEADER_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const ROW_HEADERS_BIG_LEFT = PAGE_BORDER_WIDTH;
export const ROW_HEADERS_BIG_WIDTH = 45;
export const ROW_HEADERS_BIG_HEIGHT = 27;


export const INDENT_WITDH = 10;
export const EXTERNAL_STORAGE_TOP = ROW_HEADERS_BIG_TOP + ROW_HEADERS_BIG_HEIGHT + SECTION_GAP_WIDTH;
export const EXTERNAL_STORAGE_LEFT = ROW_HEADERS_BIG_LEFT;
export const EXTERNAL_STORAGE_WIDTH = ROW_HEADERS_BIG_WIDTH;
export const EXTERNAL_STORAGE_HEIGHT = 27;
export const EXTERNAL_STORAGE_ROWS = 7;

export const ADDITIONS_TOP = EXTERNAL_STORAGE_TOP + EXTERNAL_STORAGE_HEIGHT + SECTION_GAP_WIDTH;
export const ADDITIONS_LEFT = ROW_HEADERS_BIG_LEFT;
export const ADDITIONS_WIDTH = ROW_HEADERS_BIG_WIDTH;
export const ADDITIONS_HEIGHT = 45;
export const ADDITIONS_ROWS = 8;
export const ADDITION_BASE_ROWS = 4;
export const ADDITION_BASE_OIL_BOTTOM = 
    ADDITIONS_TOP + ROW_SECTION_HEADER_HEIGHT
    + (ADDITIONS_HEIGHT - ROW_SECTION_HEADER_HEIGHT) / (ADDITIONS_ROWS + ADDITION_BASE_ROWS) * ADDITIONS_ROWS;

export const LOSSES_TOP = ADDITIONS_TOP + ADDITIONS_HEIGHT + SECTION_GAP_WIDTH;
export const LOSSES_LEFT = ROW_HEADERS_BIG_LEFT;
export const LOSSES_WIDTH = ROW_HEADERS_BIG_WIDTH;
export const LOSSES_HEIGHT = 33;
export const LOSSES_ROWS = 9;

export const FINAL_VOL_TOP = LOSSES_TOP + LOSSES_HEIGHT + SECTION_GAP_WIDTH;
export const FINAL_VOL_LEFT = ROW_HEADERS_BIG_LEFT;
export const FINAL_VOL_WIDTH = ROW_HEADERS_BIG_WIDTH;
export const FINAL_VOL_HEIGHT = ROW_SECTION_HEADER_HEIGHT;
export const FINAL_VOL_BOTTOM = FINAL_VOL_TOP + FINAL_VOL_HEIGHT;

export const COLUMN_WIDTH = 17;
export const COLUMN_START_LEFT = ROW_HEADERS_BIG_LEFT + ROW_HEADERS_BIG_WIDTH;

export const WELL_TOTALS_LEFT = PAGE_BORDER_WIDTH;
export const WELL_TOTALS_TOP = FINAL_VOL_TOP + FINAL_VOL_HEIGHT + SECTION_GAP_WIDTH;
export const WELL_TOTALS_WIDTH = FULL_WIDTH;
export const WELL_TOTALS_HEIGHT = FULL_HEIGHT - WELL_TOTALS_TOP - SECTION_GAP_WIDTH;
export const WELL_TOTALS_COL_WIDTH = 20;


// WEBPACK FOOTER //
// ./src/Services/Pdf/VolumeAccountingReport/SpecMilsVolume.ts